export enum AssignmentScheduleOptionAnswerEnum {
    yes = 1,
    maybe = 2,
    no = 3,
}